import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=704d9df4&"
import script from "./ItemDetail.vue?vue&type=script&lang=js&"
export * from "./ItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetail.vue?vue&type=style&index=0&id=704d9df4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports